import React from 'react';
import { FormulaComponentProps } from '../../types/index';
import { MathMLRenderer, createMathML } from '../shared/MathMLRenderer';

export const MyScore: React.FC<FormulaComponentProps> = ({ className, style }) => {
  const defaultStyle = {
    marginLeft: '20px',
    marginBottom: '20px',
    ...style,
  };

  const myScoreFormula = createMathML(`
    <mstyle mathsize="16px">
      <mtext>My Score</mtext>
      <mo>=</mo>
      <mn>0</mn>
      <mo>.</mo>
      <mn>5</mn>
      <mo>·</mo>
      <mtext>GENCC</mtext>
      <mo>+</mo>
      <mn>0</mn>
      <mo>.</mo>
      <mn>25</mn>
      <mo>·</mo>
      <mtext>UNIPROT</mtext>
      <mo>+</mo>
      <mn>0</mn>
      <mo>.</mo>
      <mn>25</mn>
      <mo>·</mo>
      <mtext>CLINICALTRIALS</mtext>
    </mstyle>
  `, 'inline');

  return (
    <MathMLRenderer 
      mathML={myScoreFormula} 
      className={className} 
      style={defaultStyle} 
    />
  );
};